import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { activityIdAtom } from '@store';
import { Button } from '@ui';

import { LINKS } from '../../utils/routes';

export const BackToActivityButton = () => {
    const navigate = useNavigate();
    const activityId = useAtomValue(activityIdAtom);
    return (
        <Button
            variant="secondary"
            onClick={() => {
                navigate(LINKS.getFullActivity(activityId));
            }}
        >
            Back
        </Button>
    );
};
